type MessageEntity = {
  type?: string;
  uid?: string;
  id?: string | number;
  firstName?: string;
  lastName?: string;
  businessName?: string;
  name?: string;
};

export type InternalMessageForNotification = {
  uid: string;
  text?: string;
  content?: {
    text?: string;
    body?: string;
    message?: string;
    name?: string;
    [key: string]: unknown;
  };
  sender?: MessageEntity;
};

export const getSenderDisplayName = (sender?: MessageEntity): string => {
  if (!sender) return "Someone";

  if (sender.businessName?.trim()) return sender.businessName.trim();

  const fullName = [sender.firstName, sender.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();
  if (fullName) return fullName;

  if (sender.name?.trim()) return sender.name.trim();

  return "Someone";
};

export const getMessageText = (message: InternalMessageForNotification): string => {
  return (
    message.text ||
    message.content?.text ||
    message.content?.body ||
    message.content?.message ||
    message.content?.name ||
    ""
  );
};

export const showIncomingInternalMessageBrowserNotification = (
  message: InternalMessageForNotification,
): void => {
  if (!("Notification" in window)) {
    console.warn("Browser notifications are not supported");
    return;
  }

  if (!window.isSecureContext) {
    console.warn("Browser notifications require HTTPS or localhost");
    return;
  }

  if (Notification.permission !== "granted") {
    console.warn("Browser notification permission is not granted");
    return;
  }

  if (document.visibilityState === "visible") return;

  const senderName = getSenderDisplayName(message.sender);
  const messageText = getMessageText(message);

  const title = `New message - ${senderName}`;
  const body = messageText || `New message from ${senderName}`;

  new Notification(title, {
    body,
    tag: message.uid,
  });
};
